import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { fetchStudentDetails } from 'services/AuthService'
import { studentFetchDetailsRoutine } from 'modules/auth/ducks/actions'
import { StudentProps } from 'types'

export const refreshStudentProfile = async (
  dispatch: ReturnType<typeof useDispatch>
): Promise<StudentProps> => {
  const { data } = await fetchStudentDetails()
  dispatch(studentFetchDetailsRoutine.success(data))
  return data
}

export const useOpenSrqQuizFlow = (
  openQuizModal: () => void,
  openStartModal: () => void
) => {
  const dispatch = useDispatch()

  const handleOpenSrqQuiz = useCallback(async () => {
    try {
      const profile = await refreshStudentProfile(dispatch)

      if (profile.srq_start_modal_seen) {
        openQuizModal()
        return
      }

      openStartModal()
    } catch {
      openStartModal()
    }
  }, [dispatch, openQuizModal, openStartModal])

  return handleOpenSrqQuiz
}
